import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { selectIsInApp } from '../../selectors/client';
import * as uiActions from '../../actions/ui';

import { NavigationPlugin } from '../../capacitor-connector';

const ContentfulLink = ({ uri, children, showModal, inApp, fromId }) => {
  const showSubscribeModal = e => {
    e.preventDefault();
    if (__CAPACITOR__) {
      NavigationPlugin.androidShouldOpenSubscriptionPage();
      return;
    }
    showModal('SUBSCRIBE_MODAL', { trigger: fromId });
  };

  if (uri.startsWith('https://app.idagio.com')) {
    const to = uri.replace('https://app.idagio.com', '');

    if (to.endsWith('/subscribe') && (__CAPACITOR__ || (!inApp && !__ELECTRON__))) {
      return (
        <button className="c-text-link--is-visible" onClick={showSubscribeModal}>
          {children}
        </button>
      );
    }

    return (
      <Link className="c-text-link--is-visible" onlyActiveOnIndex={false} to={to}>
        {children}
      </Link>
    );
  }

  // Sometimes mail links come mailto: links, sometimes as plain email
  // addresses, this handles both
  if (/\S+@\S+\.\S+/.test(uri) || uri.startsWith('mailto:')) {
    let emailAddress = uri;

    if (emailAddress.startsWith('mailto:')) {
      emailAddress = emailAddress.split('mailto:')[1];
    }

    const handleClick = e => {
      if (__CAPACITOR__) {
        e.preventDefault();
        NavigationPlugin.androidShouldOpenMailApp({ receiverAddress: emailAddress });
      }
    };

    return (
      <a
        className="c-text-link--is-visible"
        href={`mailto:${emailAddress}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {children}
      </a>
    );
  }

  return (
    <a className="c-text-link--is-visible" href={uri} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

ContentfulLink.propTypes = {
  uri: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showModal: PropTypes.func.isRequired,
  inApp: PropTypes.bool.isRequired,
  fromId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    inApp: selectIsInApp(state),
  };
}

export default connect(mapStateToProps, {
  showModal: uiActions.showModal,
})(ContentfulLink);
